import type { Player, StoneColor, StoneType } from './types';

/** すべての石の種類 */
export const STONE_TYPES: readonly StoneType[] = [90, 70, 50, 30, 10];

/** 先手が使用できる「通常の石」 */
export const FIRST_REGULAR_TYPES: readonly StoneType[] = [90, 70];

/** 後手が使用できる「通常の石」 */
export const SECOND_REGULAR_TYPES: readonly StoneType[] = [30, 10];

/** 50% の石は両者で使用できる */
export const SHARED_TYPE: StoneType = 50;

/** 各プレイヤーの目標色 */
export const TARGET_COLOR: Record<Player, StoneColor> = {
  first: 'black',
  second: 'white',
};

/** 石の種類ごとの「黒になる確率」p（観測時: r < p なら黒、それ以外なら白） */
export const BLACK_PROBABILITY: Record<StoneType, number> = {
  90: 0.9,
  70: 0.7,
  50: 0.5,
  30: 0.3,
  10: 0.1,
};

/** 石の種類ごとに使用できるプレイヤー */
export const ALLOWED_PLAYERS: Record<StoneType, readonly Player[]> = {
  90: ['first'],
  70: ['first'],
  50: ['first', 'second'],
  30: ['second'],
  10: ['second'],
};

/** 通常の石（50% の石を除く）か */
export function isRegularType(type: StoneType): boolean {
  return type !== SHARED_TYPE;
}

/**
 * 石の種類が指定プレイヤーの使用できる通常の石か。
 * （50% の石はここでは false を返す。50% の判定は呼び出し側で行う）
 */
export function isOwnRegularType(player: Player, type: StoneType): boolean {
  if (type === SHARED_TYPE) return false;
  const own = player === 'first' ? FIRST_REGULAR_TYPES : SECOND_REGULAR_TYPES;
  return own.includes(type);
}

/** 石の種類を日本語ラベルで表示する */
export function stoneTypeLabel(type: StoneType): string {
  return `${type}%の石`;
}

/** 石の種類の詳細説明（黒になる確率を含む） */
export function stoneTypeDescription(type: StoneType): string {
  const p = BLACK_PROBABILITY[type];
  const blackPct = Math.round(p * 100);
  const whitePct = 100 - blackPct;
  const who =
    type === SHARED_TYPE ? '先手・後手' : type === 90 || type === 70 ? '先手' : '後手';
  return `黒 ${blackPct}% / 白 ${whitePct}%（${who}）`;
}
